import { render, staticRenderFns } from "./listDetails.vue?vue&type=template&id=c4c23aa6&scoped=true&"
import script from "./listDetails.vue?vue&type=script&lang=js&"
export * from "./listDetails.vue?vue&type=script&lang=js&"
import style0 from "./listDetails.vue?vue&type=style&index=0&id=c4c23aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c23aa6",
  null
  
)

export default component.exports